import { Button } from "antd";
import styled from "styled-components";

export const Inner = styled.div`
	display: flex;
	min-height: 200px;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
	gap: 30px;
`;

export const Section = styled.div`
	${(props) =>
		props.isMobile
			? `
    width: 100%;
    overflow: auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    align-content: center;
    gap: 20px;
  `
			: `
    display: flex;
	  justify-content: center;
	  align-items: center;
    flex-direction: row;
    gap: 40px;
  `}
`;

export const AntdButton = styled(Button)`
	border-radius: 10px;
	padding: 20px;
`;
